import { computed, ref, watch } from "vue"
import {
  ORIGEN_OTROS,
  esOrigenPrincipal,
  origenCoincideConDestino,
  origenesOtros,
  origenesPrincipales
} from "@/utils/origenes"

const origenesPermitidosJPN = ["MDE", "BOG", "CLO", "CTG"]

// Maneja el select de origen con la opción "OTROS": al elegirla se muestra un
// segundo input (buscable) con todos los orígenes del JSON que no están en la
// lista principal. `origen` siempre guarda el código IATA real que se envía.
export function useOrigenOtros(origen, destino) {

  const esJapon = computed(() => !!destino.value?.includes("JPN"))

  // Un origen restaurado de sesión que no es principal arranca en modo "otros".
  const usandoOtroOrigen = ref(!!origen.value && !esOrigenPrincipal(origen.value))

  watch(origen, (codigo) => {
    if (codigo) usandoOtroOrigen.value = !esOrigenPrincipal(codigo)
  })

  const origenesDisponibles = computed(() => {

    // Japón solo sale desde estas ciudades, sin opción de otros orígenes
    if (esJapon.value) {
      return origenesPrincipales.filter(o => origenesPermitidosJPN.includes(o.value))
    }

    return [...origenesPrincipales, { value: ORIGEN_OTROS, label: "OTROS" }]

  })

  // Valor que muestra el <select>: el código principal o "OTROS".
  const origenSelect = computed({
    get: () => (usandoOtroOrigen.value ? ORIGEN_OTROS : origen.value),
    set: (valor) => {
      if (valor === ORIGEN_OTROS) {
        usandoOtroOrigen.value = true
        origen.value = ""
      } else {
        usandoOtroOrigen.value = false
        origen.value = valor
      }
    }
  })

  // Otros orígenes, sin los aeropuertos del destino elegido.
  const otrosOrigenesDisponibles = computed(() =>
    origenesOtros.filter(o => !origenCoincideConDestino(o.value, destino.value))
  )

  const otroOrigenSeleccionado = computed({
    get: () => origenesOtros.find(o => o.value === origen.value) || null,
    set: (nuevo) => {
      origen.value = nuevo?.value || ""
    }
  })

  watch(destino, () => {

    if (esJapon.value && !origenesPermitidosJPN.includes(origen.value)) {
      usandoOtroOrigen.value = false
      origen.value = "MDE"
      return
    }

    // Si el otro origen quedó igual al nuevo destino, se limpia para elegir otro
    if (usandoOtroOrigen.value && origenCoincideConDestino(origen.value, destino.value)) {
      origen.value = ""
    }

  })

  return {
    origenesDisponibles,
    origenSelect,
    usandoOtroOrigen,
    otrosOrigenesDisponibles,
    otroOrigenSeleccionado
  }
}
